<template>
  <v-container
    :class="[ 'itus-app-page', { 'library-page' : library } ]"
    fluid
    fill-height
    align-start
    justify-center
  >
    <v-navigation-drawer v-model="sideNav" absolute right temporary v-if="sideNav">
      <v-list>
        <template v-for="(item, i) in buttons">
          <v-list-item
            v-if="!item.hasSub"
            :class="'itus-button-' + item.id"
            :key="i"
            v-on:click.stop.prevent.capture="$emit('app-page-button-click', item.id)"
            :disabled="item.disabled"
          >
            <v-list-tile-action v-if="item.type === 'switch'">
              <v-switch
                :id="item.id"
                v-model="item.active"
                readonly
              ></v-switch>
            </v-list-tile-action>
            <v-list-item-icon v-else>
              <v-icon left :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item>
          <v-list-group :key="i" v-else :prepend-icon="item.icon">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title :class="'itus-button-' + item.id">{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="subitem in subButtons">
              <v-list-item
                v-if="item.id === subitem.parentId"
                :class="'itus-button-' + subitem.id"
                :key="subitem.id"
                v-on:click.stop.prevent.capture="$emit('app-page-button-click', subitem.id)"
              >
                <v-list-tile-action v-if="subitem.type === 'switch'">
                  <v-switch
                    :id="subitem.id"
                    v-model="subitem.value"
                    readonly
                  ></v-switch>
                </v-list-tile-action>
                <v-list-item-icon v-else>
                  <v-icon left :color="subitem.color">{{ subitem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{subitem.title}}</v-list-item-title>
              </v-list-item>
             </template>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <Busy :value="workingDialog.show"></Busy>
    <v-flex xs12 fill-height ma-0 pa-0>
      <v-card class="itus-app-page__main" flat tile>
        <v-toolbar class="itus-app-page__toolbar" height="40px" elevation="0" dark>
          <Breadcrumbs
            :items="calculatedBreadcrumbs"
            @crumb-click="handleCrumbClick"
          ></Breadcrumbs>
          <v-icon v-if="filtered" small right style="margin-left:20px">filter_list</v-icon>
          <v-spacer></v-spacer>
          <template v-if="label">
            <span :class="label.class" :style="label.style">{{label.text}}</span>
            <v-spacer></v-spacer>
          </template>
          <v-toolbar-items
            v-if="buttons && buttons.length > 0"
            class="d-flex align-center"
          >
            <v-btn
              small
              exact
              icon
              active-class
              class="hidden-md-and-up"
              v-on:click.stop.prevent.capture="sideNav = !sideNav"
            >
              <v-icon small>fa-square-caret-down</v-icon>
            </v-btn>
            <template v-for="item in buttons">
              <v-switch
                v-if="item.type === 'switch'"
                :id="item.id"
                :key="item.id"
                :value="item.active"
                readonly
                class="hidden-sm-and-down"
                @click.native.stop="$emit('app-page-button-click', item.id)"
                hide-details
              >
                <template v-slot:label>
                  <span class="text-button">{{item.title}}</span>
                </template>
              </v-switch>
              <template v-else-if="item.type === 'static'">
                <v-icon small left :key="item.id">{{ item.icon }}</v-icon>
                <span :key="item.id" class="text-button">{{item.title}}</span>
              </template>
              <v-btn
                small
                exact
                text
                active-class
                :class="'hidden-sm-and-down itus-button-' + item.id"
                v-else-if="!item.hasSub"
                :id="item.id"
                :key="item.id"
                v-bind:disabled="item.disabled"
                v-on:click.native.stop="$emit('app-page-button-click', item.id)"
              >
                <v-icon v-if="item.icon" small left>{{ item.icon }}</v-icon>
                {{ item.title }}
              </v-btn>
              <v-menu
                v-else
                :key="item.id"
                class="hidden-sm-and-down"
                @click.stop
                bottom
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    exact
                    text
                    active-class
                    class="hidden-sm-and-down"
                    v-bind:disabled="item.disabled"
                    :id="item.id"
                  >
                    <v-icon small :left="item.title ? true : false">{{ item.icon }}</v-icon>
                    {{item.title}}
                  </v-btn>
                </template>
                <v-list class="hidden-sm-and-down ">
                  <template v-for="subitem in subButtons">
                  <v-list-item
                    v-if="subitem.type === 'switch' && item.id === subitem.parentId"
                    :key="subitem.id"
                  >
                    <v-switch
                      v-model="subitem.value"
                      :label="subitem.title"
                      readonly
                      class="hidden-sm-and-down"
                      @click.native.stop="$emit('app-page-button-click', subitem.id)"
                      hide-details
                    >
                    </v-switch>
                  </v-list-item>
                  <v-list-item
                    class="hidden-sm-and-down"
                    v-else-if="subitem.type !== 'switch' && item.id === subitem.parentId"
                    :key="subitem.id"
                    v-bind:id="subitem.id"
                    v-bind:disabled="subitem.disabled"
                    @click.capture.stop="$emit('app-page-button-click', subitem.id)"
                  >
                    <v-list-item-title>
                      <v-icon left>{{ subitem.icon }}</v-icon>
                      {{ subitem.title }}
                    </v-list-item-title>
                  </v-list-item>
                  </template>
                </v-list>
              </v-menu>
            </template>
          </v-toolbar-items>
        </v-toolbar>
        <AlertBar
          :value="showMessage"
          @input="showMessageChanged($event)"
          :type="message.type"
          :message="message.text"
          :detail="message.detail"
        >
        </AlertBar>
        <v-snackbar
          :value="showTempMessage"
          @input="showTempMessageChanged($event)"
          :color="tempMessage.type"
          :timeout="3000"
          top
        >
        {{tempMessage.text}}
        </v-snackbar>
        <v-card-text
          v-if="$slots.default"
          ref="appPageContent"
          class="itus-app-page__content"
          :class="contentModifierClass"
          v-resize="onResize"
          d-block
          xs12
        >
          <slot></slot>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import { handleRouterError } from '@/router'
import { mapState, mapActions } from 'vuex'
import { AlertBar, Breadcrumbs, Busy, WARNING_ICON } from '@itus/ui.common'
export default {
  name: "AppPage",
  props: {
    library: {
      type: Boolean,
      description: "Applies styling for library pages",
      default() {
        return false
      }
    },
    breadcrumbs: {
      type: Array,
      description: "Breadcrumbs",
      default() {
        return []
      }
    },
    title: {
      type: String,
      description: "Page title"
    },
    iconName: {
      type: String,
      description: "Page icon"
    },
    dirty: {
      type: Boolean,
      description: "Drives whether to show the unsaved changes message on navigation"
    },
    filtered: {
      type: Boolean,
      description: "Shows/hides page filtered indicator"
    },
    buttons: {
      type: Array,
      description: "Toobar buttons"
    },
    subButtons: {
      type: Array,
      description: "Sub menu buttons"
    },
    workingDialog: {
      type: Object,
      description: "Progress dialog",
      default() {
        return {show: false}
      }
    },
    message: {
      type: Object,
      description: "Persistent message.",
      default() {
        return {type: 'error', show:false, text: ''}
      }
    },
    tempMessage: {
      type: Object,
      description: "Temporary message.",
      default() {
        return {type: 'info', show:false, text: ''}
      }
    },
    guide: {
      type: Array,
      description: "Guides.",
      default() {
        return null
      }
    },
    label: {
      type: Object,
      description: "Page label",
      default() {
        return null
      }
    }
  },
  data() {
    return {
      showGuide: false,
      showMessage: false,
      showTempMessage: false,
      sideNav: false,
      cardHeight: "100px",
      unsavedChangesPromise: null
    }
  },
  components: {
    Breadcrumbs,
    Busy,
    AlertBar
  },
  computed: {
    ...mapState({
      sessionTimeoutShown: state => state.sessionTimeoutShown,
    }),
    contentModifierClass() {
      if (this.message && this.message.show){
        return 'itus-app-page__content--with-alert'
      }
      return null
    },
    calculatedBreadcrumbs() {
      let calcCrumbs = []
      if(!this.breadcrumbs || (this.breadcrumbs && this.breadcrumbs.length === 0)) {
        calcCrumbs.push({ id: 'page', title: this.title, icon: this.iconName })
      } else {
        calcCrumbs = this.breadcrumbs
      }

      return calcCrumbs
    }
  },
  watch: {
    message() {
      this.showMessage = this.message.show
    },
    tempMessage() {
      this.showTempMessage = this.tempMessage.show
    },
    contentModifierClass() {
      //  Changing mofifier class modifies the size of the content slot even though
      //  the window has not resized, so send the resize event here as well.
      this.$nextTick(() => this.$emit('app-page-content-resize'))
    },
    guide: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.setGuide(newVal)
      }
    },
    dirty: {
      handler(newVal) {
        this.$store.dispatch('setDirty', newVal)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setGuide: 'setGuide',
      clearGuide: 'clearGuide'
    }),
    closeVideo() {
      this.showGuide = false
    },
    handleCrumbClick(crumb, eventArgs) {
      if (crumb.url && this.$router.currentRoute.fullPath !== crumb.url ){
        if (eventArgs && eventArgs.ctrlKey){
          let routeData = this.$router.resolve(crumb.url)
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push(crumb.url).catch(handleRouterError)
        }
      } else {
        this.$emit('crumb-click', crumb.id)
      }
    },
    cleanUpBeforeLeave() {
      this.clearGuide()
    },
    async beforeRouteLeave(to, from, next) {
      if(!this.dirty || this.sessionTimeoutShown) {
        this.cleanUpBeforeLeave()
        next()
      } else {
        let res = await this.showUnsavedChanges()

        if(res) {
          this.cleanUpBeforeLeave()
          next()
        } else {
          next(false)
        }
      }
    },
    onResize() {
      this.$emit('app-page-content-resize')
    },
    showUnsavedChanges() {
      if (!this.unsavedChangesPromise) {
        this.unsavedChangesPromise = this.$root.$confirm('Unsaved Changes','Your unsaved changes will be discarded if you leave now.',{
          warning: true,
          icon: WARNING_ICON,
          noText: 'Stay',
          yesText: 'Leave'
        })
        this.unsavedChangesPromise.finally(() => this.unsavedChangesPromise = null)
      }
      return this.unsavedChangesPromise
    },
    async preventNav(event) {
      if (!this.dirty) {
        this.cleanUpBeforeLeave()
        return
      }
      event.preventDefault()
      event.returnValue = ""
    },
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    initializeScroll() {
      if (!this.$refs.appPageContent) {
        setTimeout(this.initializeScroll, 250)
        return
      }
      this.$refs.appPageContent.addEventListener('scroll', this.handleScroll)
    },
    showMessageChanged(e) {
      this.showMessage = e
      this.$emit('show-message', e)
    },
    showTempMessageChanged(e) {
      this.showTempMessage = e
      this.$emit('show-temp-message', e)
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  },
  mounted() {
    this.initializeScroll()
  },
  beforeDestroy() {
    this.$refs.appPageContent.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener("beforeunload", this.preventNav)
  }
}
</script>
<style scoped lang="scss">
$app-bar-height: 48px;
$page-toolbar-height: 40px;
$page-alert-bar-height: 40px;
$gradient-height: 4px;

.fade-enter-active, .fade-leave-active {
  transition: opacity .7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.itus-app-page {
  .itus-app-page__main {
    height: 100%;

    .itus-app-page__toolbar {
      background-color: var(--v-primary-base);
    }
  }

  &.library-page {

    .itus-app-page__toolbar {
      background-color: var(--v-accent-base);

      ::v-deep .v-btn {
        color: var(--v-primary-base);
      }
      ::v-deep .v-btn.v-btn--disabled {
        color: rgba(15, 63, 114, 0.3)!important;
      }
      ::v-deep .v-btn.v-btn--disabled .v-icon {
        color: rgba(15, 63, 114, 0.3)!important;
      }
      ::v-deep .v-icon.fa-angle-right {
        color: var(--v-primary-base);
      }
    }
  }

  .itus-app-page__content {
    //  TODO: The below style SHOULD be able to be changed to just "height: calc(100% - #{$page-toolbar-height});"
    //  However, there is some odd layout on the analytic designer diagram that makes this 'vh'-based style
    //  necessary. Not sure the reason. Once we figure out that layout issue then we can change this to the
    //  simpler style. The symptoms on that page are that the height:100% styles are not being honored so the
    //  UI pushes below the page and inserts a scroll bar.
    height: calc(100vh - #{$app-bar-height} - #{$gradient-height} - #{$page-toolbar-height});
    padding: 0;
    overflow: auto;

    &.itus-app-page__content--with-alert {
      height: calc(100vh - #{$app-bar-height} - #{$gradient-height} - #{$page-toolbar-height} - #{$page-alert-bar-height});
    }
  }

  .itus-app-page__toolbar {
    .v-input {
      padding: 0 12.4444444444px;
      .text-button {
        font-size: 0.75rem !important;
        color: white;
      }
    }
  }
}
</style>